/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Locations API
 * Scrivio API for location management.  Locations represent physical office locations/branches where clients can be served.  ## Authentication All endpoints require Firebase Authentication JWT token in `Authorization: Bearer <token>` header.  ## Error Responses All error responses follow RFC 7807 Problem Details format. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@scrivio.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface CreateLocationRequest {
    /**
     * Location name
     */
    'name': string;
    /**
     * Location description
     */
    'description'?: string | null;
    /**
     * Street address
     */
    'addressStreet'?: string | null;
    /**
     * City
     */
    'addressCity'?: string | null;
    /**
     * Postal code
     */
    'addressPostalCode'?: string | null;
    /**
     * Phone number
     */
    'phone'?: string | null;
    /**
     * Email address
     */
    'email'?: string | null;
    /**
     * AGB code for this location - 8-digit healthcare provider identifier (Algemeen GegevensBeheer)
     */
    'agbCode'?: string | null;
}
export interface CreateRoomRequest {
    /**
     * Location ID (required for org-scoped endpoint, optional when using location-scoped endpoint)
     */
    'locationId'?: string;
    /**
     * Room name
     */
    'name': string;
    /**
     * Room capacity (number of people), defaults to 2
     */
    'capacity'?: number;
}
export interface LocationResponse {
    /**
     * Location ID
     */
    'id': string;
    /**
     * Organization ID
     */
    'organizationId': string;
    /**
     * Location name
     */
    'name': string;
    /**
     * Location description
     */
    'description'?: string | null;
    /**
     * Street address
     */
    'addressStreet'?: string | null;
    /**
     * City
     */
    'addressCity'?: string | null;
    /**
     * Postal code
     */
    'addressPostalCode'?: string | null;
    /**
     * Phone number
     */
    'phone'?: string | null;
    /**
     * Email address
     */
    'email'?: string | null;
    /**
     * AGB code for this location (overrides organization default) - 8-digit healthcare provider identifier (existing data may not match the format)
     */
    'agbCode'?: string | null;
    /**
     * Whether the location is active
     */
    'isActive': boolean;
    /**
     * Creation timestamp in milliseconds
     */
    'createdAt': number;
    /**
     * Last update timestamp in milliseconds
     */
    'updatedAt': number;
}
export interface ProblemDetail {
    /**
     * A URI reference that identifies the problem type
     */
    'type': string;
    /**
     * A short, human-readable summary of the problem
     */
    'title': string;
    /**
     * The HTTP status code
     */
    'status': number;
    /**
     * A human-readable explanation specific to this occurrence
     */
    'detail'?: string;
    /**
     * A URI reference that identifies the specific occurrence
     */
    'instance'?: string;
    /**
     * List of validation errors
     */
    'errors'?: Array<ProblemDetailErrorsInner>;
}
export interface ProblemDetailErrorsInner {
    'field'?: string;
    'message'?: string;
}
export interface RoomAvailabilityResponse {
    /**
     * Room ID
     */
    'roomId': string;
    /**
     * Whether the room is available for the requested time range
     */
    'available': boolean;
    'conflictingAppointment'?: RoomAvailabilityResponseConflictingAppointment | null;
}
/**
 * Details of conflicting appointment (if not available)
 */
export interface RoomAvailabilityResponseConflictingAppointment {
    /**
     * Conflicting appointment ID
     */
    'appointmentId'?: string;
    /**
     * Conflicting appointment title
     */
    'title'?: string;
    /**
     * Start time of conflicting appointment
     */
    'startTime'?: number;
    /**
     * End time of conflicting appointment
     */
    'endTime'?: number;
}
export interface RoomCalendarEvent {
    /**
     * Appointment ID
     */
    'appointmentId': string;
    /**
     * ID of the room this event belongs to (used for per-room colouring in combined views)
     */
    'roomId': string;
    /**
     * Event title (appointment subject or client name)
     */
    'title': string;
    /**
     * Start time (Unix timestamp in milliseconds)
     */
    'startTime': number;
    /**
     * End time (Unix timestamp in milliseconds)
     */
    'endTime': number;
    /**
     * Name of the behandelaar
     */
    'behandelaarName'?: string | null;
    /**
     * Appointment status
     */
    'status'?: string | null;
}
export interface RoomResponse {
    /**
     * Room ID
     */
    'id': string;
    /**
     * Location ID
     */
    'locationId': string;
    /**
     * Location name (denormalized for display)
     */
    'locationName': string;
    /**
     * Room name
     */
    'name': string;
    /**
     * Room capacity (number of people)
     */
    'capacity': number;
    /**
     * Whether the room is active
     */
    'isActive': boolean;
    /**
     * Creation timestamp in milliseconds
     */
    'createdAt': number;
    /**
     * Last update timestamp in milliseconds
     */
    'updatedAt': number;
}
export interface UpdateLocationRequest {
    /**
     * Location name
     */
    'name'?: string;
    /**
     * Location description
     */
    'description'?: string | null;
    /**
     * Street address
     */
    'addressStreet'?: string | null;
    /**
     * City
     */
    'addressCity'?: string | null;
    /**
     * Postal code
     */
    'addressPostalCode'?: string | null;
    /**
     * Phone number
     */
    'phone'?: string | null;
    /**
     * Email address
     */
    'email'?: string | null;
    /**
     * AGB code for this location - 8-digit healthcare provider identifier (Algemeen GegevensBeheer)
     */
    'agbCode'?: string | null;
    /**
     * Whether the location is active
     */
    'isActive'?: boolean;
}
export interface UpdateRoomRequest {
    /**
     * Room name
     */
    'name'?: string;
    /**
     * Room capacity (number of people)
     */
    'capacity'?: number;
    /**
     * Whether the room is active
     */
    'isActive'?: boolean;
}

/**
 * LocationsApi - axios parameter creator
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new location (requires locations.create permission)
         * @summary Create location
         * @param {CreateLocationRequest} createLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (createLocationRequest: CreateLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLocationRequest' is not null or undefined
            assertParamExists('createLocation', 'createLocationRequest', createLocationRequest)
            const localVarPath = `/api/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a location (requires locations.delete permission)
         * @summary Delete location
         * @param {string} locationId Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocation', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a location by ID (must be in the same organization)
         * @summary Get location by ID
         * @param {string} locationId Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById: async (locationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationById', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all locations in the authenticated user\'s organization
         * @summary List locations in organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a location\'s details (requires locations.update permission)
         * @summary Update location
         * @param {string} locationId Location ID
         * @param {UpdateLocationRequest} updateLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (locationId: string, updateLocationRequest: UpdateLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocation', 'locationId', locationId)
            // verify required parameter 'updateLocationRequest' is not null or undefined
            assertParamExists('updateLocation', 'updateLocationRequest', updateLocationRequest)
            const localVarPath = `/api/v1/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new location (requires locations.create permission)
         * @summary Create location
         * @param {CreateLocationRequest} createLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(createLocationRequest: CreateLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(createLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a location (requires locations.delete permission)
         * @summary Delete location
         * @param {string} locationId Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.deleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a location by ID (must be in the same organization)
         * @summary Get location by ID
         * @param {string} locationId Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationById(locationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationById(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all locations in the authenticated user\'s organization
         * @summary List locations in organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a location\'s details (requires locations.update permission)
         * @summary Update location
         * @param {string} locationId Location ID
         * @param {UpdateLocationRequest} updateLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(locationId: string, updateLocationRequest: UpdateLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(locationId, updateLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * Create a new location (requires locations.create permission)
         * @summary Create location
         * @param {CreateLocationRequest} createLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(createLocationRequest: CreateLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponse> {
            return localVarFp.createLocation(createLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a location (requires locations.delete permission)
         * @summary Delete location
         * @param {string} locationId Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(locationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a location by ID (must be in the same organization)
         * @summary Get location by ID
         * @param {string} locationId Location ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationById(locationId: string, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponse> {
            return localVarFp.getLocationById(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all locations in the authenticated user\'s organization
         * @summary List locations in organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations(options?: RawAxiosRequestConfig): AxiosPromise<Array<LocationResponse>> {
            return localVarFp.listLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * Update a location\'s details (requires locations.update permission)
         * @summary Update location
         * @param {string} locationId Location ID
         * @param {UpdateLocationRequest} updateLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(locationId: string, updateLocationRequest: UpdateLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponse> {
            return localVarFp.updateLocation(locationId, updateLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 */
export class LocationsApi extends BaseAPI {
    /**
     * Create a new location (requires locations.create permission)
     * @summary Create location
     * @param {CreateLocationRequest} createLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLocation(createLocationRequest: CreateLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).createLocation(createLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a location (requires locations.delete permission)
     * @summary Delete location
     * @param {string} locationId Location ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLocation(locationId: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).deleteLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a location by ID (must be in the same organization)
     * @summary Get location by ID
     * @param {string} locationId Location ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLocationById(locationId: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationById(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all locations in the authenticated user\'s organization
     * @summary List locations in organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listLocations(options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a location\'s details (requires locations.update permission)
     * @summary Update location
     * @param {string} locationId Location ID
     * @param {UpdateLocationRequest} updateLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLocation(locationId: string, updateLocationRequest: UpdateLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).updateLocation(locationId, updateLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoomsApi - axios parameter creator
 */
export const RoomsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if a room is available (not booked) for a given time range. Returns availability status and any conflicting appointments. 
         * @summary Check room availability
         * @param {string} roomId Room ID
         * @param {number} startTime Start of time range (Unix timestamp in milliseconds)
         * @param {number} endTime End of time range (Unix timestamp in milliseconds)
         * @param {string} [excludeAppointmentId] Appointment ID to exclude from conflict check (for editing existing appointments)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRoomAvailability: async (roomId: string, startTime: number, endTime: number, excludeAppointmentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('checkRoomAvailability', 'roomId', roomId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('checkRoomAvailability', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('checkRoomAvailability', 'endTime', endTime)
            const localVarPath = `/api/v1/rooms/{roomId}/availability`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (excludeAppointmentId !== undefined) {
                localVarQueryParameter['excludeAppointmentId'] = excludeAppointmentId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new room in a location (requires rooms.create permission)
         * @summary Create room
         * @param {CreateRoomRequest} createRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom: async (createRoomRequest: CreateRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoomRequest' is not null or undefined
            assertParamExists('createRoom', 'createRoomRequest', createRoomRequest)
            const localVarPath = `/api/v1/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a room (requires rooms.delete permission)
         * @summary Delete room
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('deleteRoom', 'roomId', roomId)
            const localVarPath = `/api/v1/rooms/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a room by ID (must be in the same organization)
         * @summary Get room by ID
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomById: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRoomById', 'roomId', roomId)
            const localVarPath = `/api/v1/rooms/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns appointments for a room within a date range
         * @summary Get room calendar
         * @param {string} roomId Room ID
         * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
         * @param {number} endTime End of date range (Unix timestamp in milliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomCalendar: async (roomId: string, startTime: number, endTime: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRoomCalendar', 'roomId', roomId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getRoomCalendar', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getRoomCalendar', 'endTime', endTime)
            const localVarPath = `/api/v1/rooms/{roomId}/calendar`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns appointments for multiple rooms within a date range in a single request, avoiding N+1 per-room calls. When roomIds is omitted, all rooms in the organization are included. Each event is tagged with its roomId so the caller can colour events per room.
         * @summary Get calendar for multiple rooms
         * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
         * @param {number} endTime End of date range (Unix timestamp in milliseconds)
         * @param {Array<string>} [roomIds] Rooms to include. When omitted, all rooms in the organization are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomsCalendar: async (startTime: number, endTime: number, roomIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getRoomsCalendar', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getRoomsCalendar', 'endTime', endTime)
            const localVarPath = `/api/v1/rooms/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = endTime;
            }

            if (roomIds) {
                localVarQueryParameter['roomIds'] = roomIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all rooms across all locations in the authenticated user\'s organization
         * @summary List all rooms in organization
         * @param {string} [locationId] Filter by location ID
         * @param {boolean} [activeOnly] Only return active rooms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRooms: async (locationId?: string, activeOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a room\'s details (requires rooms.update permission)
         * @summary Update room
         * @param {string} roomId Room ID
         * @param {UpdateRoomRequest} updateRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom: async (roomId: string, updateRoomRequest: UpdateRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('updateRoom', 'roomId', roomId)
            // verify required parameter 'updateRoomRequest' is not null or undefined
            assertParamExists('updateRoom', 'updateRoomRequest', updateRoomRequest)
            const localVarPath = `/api/v1/rooms/{roomId}`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoomRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomsApi - functional programming interface
 */
export const RoomsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomsApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if a room is available (not booked) for a given time range. Returns availability status and any conflicting appointments. 
         * @summary Check room availability
         * @param {string} roomId Room ID
         * @param {number} startTime Start of time range (Unix timestamp in milliseconds)
         * @param {number} endTime End of time range (Unix timestamp in milliseconds)
         * @param {string} [excludeAppointmentId] Appointment ID to exclude from conflict check (for editing existing appointments)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkRoomAvailability(roomId: string, startTime: number, endTime: number, excludeAppointmentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkRoomAvailability(roomId, startTime, endTime, excludeAppointmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.checkRoomAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new room in a location (requires rooms.create permission)
         * @summary Create room
         * @param {CreateRoomRequest} createRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoom(createRoomRequest: CreateRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoom(createRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.createRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a room (requires rooms.delete permission)
         * @summary Delete room
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoom(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoom(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.deleteRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a room by ID (must be in the same organization)
         * @summary Get room by ID
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomById(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomById(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.getRoomById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns appointments for a room within a date range
         * @summary Get room calendar
         * @param {string} roomId Room ID
         * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
         * @param {number} endTime End of date range (Unix timestamp in milliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomCalendar(roomId: string, startTime: number, endTime: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoomCalendarEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomCalendar(roomId, startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.getRoomCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns appointments for multiple rooms within a date range in a single request, avoiding N+1 per-room calls. When roomIds is omitted, all rooms in the organization are included. Each event is tagged with its roomId so the caller can colour events per room.
         * @summary Get calendar for multiple rooms
         * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
         * @param {number} endTime End of date range (Unix timestamp in milliseconds)
         * @param {Array<string>} [roomIds] Rooms to include. When omitted, all rooms in the organization are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomsCalendar(startTime: number, endTime: number, roomIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoomCalendarEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomsCalendar(startTime, endTime, roomIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.getRoomsCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all rooms across all locations in the authenticated user\'s organization
         * @summary List all rooms in organization
         * @param {string} [locationId] Filter by location ID
         * @param {boolean} [activeOnly] Only return active rooms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRooms(locationId?: string, activeOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoomResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRooms(locationId, activeOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.listRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a room\'s details (requires rooms.update permission)
         * @summary Update room
         * @param {string} roomId Room ID
         * @param {UpdateRoomRequest} updateRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoom(roomId: string, updateRoomRequest: UpdateRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoom(roomId, updateRoomRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoomsApi.updateRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoomsApi - factory interface
 */
export const RoomsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomsApiFp(configuration)
    return {
        /**
         * Check if a room is available (not booked) for a given time range. Returns availability status and any conflicting appointments. 
         * @summary Check room availability
         * @param {string} roomId Room ID
         * @param {number} startTime Start of time range (Unix timestamp in milliseconds)
         * @param {number} endTime End of time range (Unix timestamp in milliseconds)
         * @param {string} [excludeAppointmentId] Appointment ID to exclude from conflict check (for editing existing appointments)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRoomAvailability(roomId: string, startTime: number, endTime: number, excludeAppointmentId?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomAvailabilityResponse> {
            return localVarFp.checkRoomAvailability(roomId, startTime, endTime, excludeAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new room in a location (requires rooms.create permission)
         * @summary Create room
         * @param {CreateRoomRequest} createRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom(createRoomRequest: CreateRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoomResponse> {
            return localVarFp.createRoom(createRoomRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a room (requires rooms.delete permission)
         * @summary Delete room
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom(roomId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRoom(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a room by ID (must be in the same organization)
         * @summary Get room by ID
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomById(roomId: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomResponse> {
            return localVarFp.getRoomById(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns appointments for a room within a date range
         * @summary Get room calendar
         * @param {string} roomId Room ID
         * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
         * @param {number} endTime End of date range (Unix timestamp in milliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomCalendar(roomId: string, startTime: number, endTime: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoomCalendarEvent>> {
            return localVarFp.getRoomCalendar(roomId, startTime, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns appointments for multiple rooms within a date range in a single request, avoiding N+1 per-room calls. When roomIds is omitted, all rooms in the organization are included. Each event is tagged with its roomId so the caller can colour events per room.
         * @summary Get calendar for multiple rooms
         * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
         * @param {number} endTime End of date range (Unix timestamp in milliseconds)
         * @param {Array<string>} [roomIds] Rooms to include. When omitted, all rooms in the organization are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomsCalendar(startTime: number, endTime: number, roomIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoomCalendarEvent>> {
            return localVarFp.getRoomsCalendar(startTime, endTime, roomIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all rooms across all locations in the authenticated user\'s organization
         * @summary List all rooms in organization
         * @param {string} [locationId] Filter by location ID
         * @param {boolean} [activeOnly] Only return active rooms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRooms(locationId?: string, activeOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoomResponse>> {
            return localVarFp.listRooms(locationId, activeOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a room\'s details (requires rooms.update permission)
         * @summary Update room
         * @param {string} roomId Room ID
         * @param {UpdateRoomRequest} updateRoomRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom(roomId: string, updateRoomRequest: UpdateRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<RoomResponse> {
            return localVarFp.updateRoom(roomId, updateRoomRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomsApi - object-oriented interface
 */
export class RoomsApi extends BaseAPI {
    /**
     * Check if a room is available (not booked) for a given time range. Returns availability status and any conflicting appointments. 
     * @summary Check room availability
     * @param {string} roomId Room ID
     * @param {number} startTime Start of time range (Unix timestamp in milliseconds)
     * @param {number} endTime End of time range (Unix timestamp in milliseconds)
     * @param {string} [excludeAppointmentId] Appointment ID to exclude from conflict check (for editing existing appointments)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkRoomAvailability(roomId: string, startTime: number, endTime: number, excludeAppointmentId?: string, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).checkRoomAvailability(roomId, startTime, endTime, excludeAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new room in a location (requires rooms.create permission)
     * @summary Create room
     * @param {CreateRoomRequest} createRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createRoom(createRoomRequest: CreateRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).createRoom(createRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a room (requires rooms.delete permission)
     * @summary Delete room
     * @param {string} roomId Room ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteRoom(roomId: string, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).deleteRoom(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a room by ID (must be in the same organization)
     * @summary Get room by ID
     * @param {string} roomId Room ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRoomById(roomId: string, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getRoomById(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns appointments for a room within a date range
     * @summary Get room calendar
     * @param {string} roomId Room ID
     * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
     * @param {number} endTime End of date range (Unix timestamp in milliseconds)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRoomCalendar(roomId: string, startTime: number, endTime: number, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getRoomCalendar(roomId, startTime, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns appointments for multiple rooms within a date range in a single request, avoiding N+1 per-room calls. When roomIds is omitted, all rooms in the organization are included. Each event is tagged with its roomId so the caller can colour events per room.
     * @summary Get calendar for multiple rooms
     * @param {number} startTime Start of date range (Unix timestamp in milliseconds)
     * @param {number} endTime End of date range (Unix timestamp in milliseconds)
     * @param {Array<string>} [roomIds] Rooms to include. When omitted, all rooms in the organization are returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRoomsCalendar(startTime: number, endTime: number, roomIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getRoomsCalendar(startTime, endTime, roomIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all rooms across all locations in the authenticated user\'s organization
     * @summary List all rooms in organization
     * @param {string} [locationId] Filter by location ID
     * @param {boolean} [activeOnly] Only return active rooms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listRooms(locationId?: string, activeOnly?: boolean, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).listRooms(locationId, activeOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a room\'s details (requires rooms.update permission)
     * @summary Update room
     * @param {string} roomId Room ID
     * @param {UpdateRoomRequest} updateRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRoom(roomId: string, updateRoomRequest: UpdateRoomRequest, options?: RawAxiosRequestConfig) {
        return RoomsApiFp(this.configuration).updateRoom(roomId, updateRoomRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



